<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>


      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تجربه
        </b-button>
      </b-col>
    </b-row>
    <div v-if="experiences">
      <b-row>
        <b-col sm="12" md="5" lg="4">
          <b-form-group label="تاریخ شروع:" label-for="start-date">
            <date-picker
                v-model="filters.dateStart"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                :placeholder="'انتخاب تاریخ شروع'"
                :auto-submit="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="5" lg="4">
          <b-form-group label="تاریخ پایان:" label-for="end-date">
            <date-picker
                v-model="filters.dateEnd"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                :placeholder="'انتخاب تاریخ پایان'"
                :auto-submit="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12" md="2" lg="4" class="d-flex align-items-end">
          <b-button @click="getExperiences" variant="primary">اعمال فیلترها</b-button>
        </b-col>
      </b-row>


      <b-row>


        <b-col sm="12" md="7" lg="8">
          <search-services
              @searchBase="searchBase"
              :selectedFilter="selectedFilter"
              :submitLoading="searchBasesubmitLoading"
              :isSearchResult="isSearchResult"
              ref="ownersSearchComponent"
              class="w-100"
              v-model="searchInput"
          />
        </b-col>
      </b-row>
      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>کد</b-th>
            <b-th>ترتیب</b-th>
            <b-th>عنوان</b-th>
            <b-th>شهر</b-th>
            <b-th>میزبان</b-th>
            <b-th>هزینه</b-th>
            <b-th>وضعیت تقویم</b-th>
            <b-th> نمایش ص اصلی </b-th>
            <b-th>آژانس</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr  v-for="(experience, index) in experiences" :key="experience.id">
            <b-th>
              <a
                  target="_blank"
                  :href="
                  'https://roomtoor.com/event/' +
                  experience.category.slug +
                  '-' +
                  experience.code
                "
              >
                {{ experience.code }}
              </a>
            </b-th>

            <b-th>
              <span v-if="experience.show_order_number">
                {{ experience.show_order_number}}
              </span>
              <span v-else>
                ----
              </span>
            </b-th>

            <b-th>
              <a
                  target="_blank"
                  :href="
                  'https://roomtoor.com/event/' +
                  experience.category.slug +
                  '-' +
                  experience.code
                "
              >
                {{ experience.name }}
              </a>
            </b-th>
            <b-td>
              {{ experience.city.name }}
            </b-td>

            <b-td>
              <a :href="`https://roomtoor.com/user/host/${experience.host.token}`" target="_blank">
                <span class="pl-1">      {{ experience.host.full_name }}</span>
              </a>
              <br/>
              <a href="">
                <b-badge variant="primary" v-if="experience.host.mobile">
                  {{   experience.host.mobile.replace("+98","0") }}
                </b-badge>
              </a>
            </b-td>
<!--            <b-td>
              {{
                new Date(experience.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>-->
            <b-th>
              <span v-if="experience.experience_dates[0]" class="text-success">
                   {{experience.experience_dates[0].prices.normal_dayes}}
              </span>
              <span v-else class="text-danger">
                قیمت  ندارد
              </span>
            </b-th>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="experience.close_booking === 'active'" style="color: #00c700">
                    باز
                  </span>
                <span v-else>
                  بسته
                </span>
              </b-col>
            </b-td>

            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0">
                  <span class="font-weight-bold" v-if="experience.show_index_page === true" style="color: #00c700">
                    فعال
                  </span>
                <span v-else>
                  غیرفعال
                </span>
              </b-col>
            </b-td>
            <b-td>
                <span v-if="experience.agency==='active'" style="color: #00c700">
                  فعال
                </span>
              <span v-else>
                غیرفعال
              </span>
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  experience.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ experience.status == "active" ? "" : "غیر" }}فعال
              </b-col>
            </b-td>

            <b-td>
              <b-col class="d-flex align-items-center">
                <router-link
                    v-if="experience.checkItems[0] && experience.checkItems[0].serviceable_type==='App\\Models\\Experience'"
                    :to="{ name: 'checkItems', params: {type:'experience', id: experience.id,name:experience.name } }"
                    variant="flat-primary"
                    v-b-tooltip.hover.top="experience.checkItems[0].description"
                    class="font-weight-bolder btn"
                >
                  <AlertTriangleIcon style="color: #00b782" v-if="experience.checkItems[0].status==='complete'" />
                  <AlertTriangleIcon v-else style="color: #fcb200" />
                </router-link>
                <router-link
                    v-else
                    :to="{ name: 'checkItems', params: {type:'experience', id: experience.id,name:experience.name } }"
                    variant="flat-primary"
                    v-b-tooltip.hover.top="'مشکلی ثبت نشده'"
                    class="font-weight-bolder btn"
                >
                  <AlertTriangleIcon />

                </router-link>
<!--                <router-link
                    :to="{ name: 'statisticsOneEvents', params: {type:'experience', id: experience.id,name:experience.name } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <feather-icon
                      icon="SlidersIcon"
                      size="28"
                  />
                </router-link>-->
                 <router-link
                  :to="{ name: 'specificTypeComments', params: {type:'experience', id: experience.id } }"
                  variant="flat-secondary"
                  class="font-weight-bolder btn"
                >
                  <BIconChatRightTextFill />
                </router-link>
                <router-link
                    :to="{ name: 'eventsBlockCalender', params: { id: experience.id },query:{name:experience.name} }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <MinusCircleIcon />
                </router-link>
                <router-link
                    :to="{ name: 'eventsCalender', params: { id: experience.id } }"
                    variant="flat-secondary"
                    class="font-weight-bolder btn"
                >
                  <BIconCalendar />
                </router-link>
<!--                <b-button
                    @click="showConfirmModal(experience)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>-->
                <b-button
                    @click="showFormModal(experience, index)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              >
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <pagination
          ref="experiencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="98%"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
        id="experience_wizard"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تجربه" : "ایجاد تجربه" }}
            </h3>
          </div>
        </div>
      </template>
      <experience-wizard
          @deleteImage="deleteImage"
          ref="experienceInput"
          @getExperiences="getExperiences"
          :provinces="provinces"

      ></experience-wizard>


    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIconCalendar,
  BIconChatRightTextFill,
  VBTooltip, BBadge
} from "bootstrap-vue";
import Ripple from 'vue-ripple-directive'
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import SearchServices from "@/components/SearchServices.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import { mapMutations, mapState, mapActions } from "vuex";
import { forEach } from "postcss-rtl/lib/affected-props";
import ExperienceWizard from "@/components/ExperienceWizard.vue";
import AlertTriangleIcon from "vue-feather-icons/icons/AlertTriangleIcon";
import debounce from 'lodash/debounce';
import MinusCircleIcon from "vue-feather-icons/icons/MinusCircleIcon";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    BBadge,
    MinusCircleIcon,
    AlertTriangleIcon,
    ExperienceWizard,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    SearchServices,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BIconCalendar,
    BIconChatRightTextFill,
    datePicker: VuePersianDatetimePicker,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      filters: {
        dateStart: '',
        dateEnd: '',
      },
      isSearchResult:false,
      searchBasesubmitLoading:false,
      selectedFilter:[],
      Dates: [],
      experienceIndex: 0,
      itemArray: [
        {
          Item: "ACC",
          Price: 10,
          hasPrice: true,
        },
        {
          Item: "BCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "CCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "DCC",
          Price: "",
          hasPrice: false,
        },
        {
          Item: "ECC",
          Price: "",
          hasPrice: false,
        },
      ],
      provinces: [],

      perPage: 30,
      page: 1,
      buildings: [],
      experiences: null,

      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "شهر",
          slug: "city",
          sortable: false,
        },
        {
          title: "ساختمان",
          slug: "building",
          sortable: true,
        },
        {
          title: "نام",
          slug: "name",
          sortable: true,
        },
        {
          title: "میزبان",
          slug: "owner",
          sortable: false,
        },
        {
          title: "تعداد",
          slug: "count",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      experienceInput: {
        id: "",
        building_id: "",
        name: "",
        description: "",
        body: "",
        count: "",
        bedrooms: "",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getExperiences();
    this.getExperiencesPrerequisite("regulations", "regulations");
    this.getExperiencesPrerequisite("rules", "rules");
    this.getExperiencesPrerequisite("categories", "categories");
    this.getExperiencesPrerequisite("properties", "properties");
    this.getExperiencesPrerequisite("ages", "ages");
    this.getProvinces();
    this.getUrlParams();
  },
  watch: {
/*    searchInput(value) {
      this.page = 1;
      this.getExperiences();
    },*/
    perPage(value) {
      this.page = 1;
      this.getExperiences();
    },
    page(value) {
      this.getExperiences();
    },
    searchInput(value) {
      this.page = 1; // Reset the page to the beginning
      if (value.trim().length) { // Ensure there is actual input to search for
        this.debouncedGetReservations();
      }
    },
/*    searchInput() {
      if (this.searchInput) {
        this.getExperiences();
      }
    },
    selectedFilter: {
      deep: true,
      handler() {
        if (this.selectedFilter.length && this.searchInput) {
          this.getExperiences();
        }
      }
    }*/
  },
  computed: {
    ...mapState([
      "regulations_state",
      "rules_state",
      "categories_state",
      "properties_state",
      "ages_state",
    ]),
  },
  created() {
    this.debouncedGetReservations = debounce(this.getExperiences, 500);
  },
  methods: {
    getUrlParams() {
      if ("filter[name]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[name]`];
        this.selectedFilter.push("name");
      }
      if ("filter[code]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[code]`];
        this.selectedFilter.push("code");
      }
      if ("filter[host]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[host]`];
        this.selectedFilter.push("host");
      }
      if ("filter[city]" in this.$route.query) {
        this.searchInput = this.$route.query[`filter[city]`];
        this.selectedFilter.push("city");
      }
      if ("per_page" in this.$route.query) {
        this.perPage = Number(this.$route.query[`per_page`]);
        this.$refs.userPerPageComponent.perPage = this.perPage;
      }
      if ("page" in this.$route.query) {
        this.page = this.$route.query[`page`];
      }
    },
    searchBase(data) {
      console.log("data", data);
      this.selectedFilter = data.selectedFilter;
      this.searchInput = data.searchInput;
      this.isSearchResult = this.searchInput !== "" && data.type !== "delete";
      this.searchBasesubmitLoading = true;
      this.getExperiences();
    },

/*    searchBase(data) {
      console.log("data", data);

      // Only update searchInput and selectedFilter if needed
      if (data.selectedFilter.length > 0) {
        const filterCriteria = ['name', 'code', 'host', 'city'];
        const isFilterSelected = data.selectedFilter.some(filter => filterCriteria.includes(filter));
        if (isFilterSelected) {
          this.searchInput = data.searchInput;
        }
        this.selectedFilter = data.selectedFilter;
      }

      this.searchBasesubmitLoading = true;

      this.isSearchResult = !!this.searchInput;

      if (data.type === "delete") {
        this.isSearchResult = false;
      }
      this.getExperiences();
    },*/

/*    searchBase(data) {
      console.log("data", data);
      this.selectedFilter = [];
      if (data.selectedFilter.length > 0) {
        data.selectedFilter.forEach((item) => {
          if (item == "name") {
            this.searchInput = data.searchInput;
          } else if (item == "code") {
            this.searchInput = data.searchInput;
          } else if (item == "host") {
            this.searchInput = data.searchInput;
          }
          else if (item == "city") {
            this.searchInput = data.searchInput;
          }
        });
        this.selectedFilter = data.selectedFilter;
      }
      this.searchBasesubmitLoading = true;
      if (this.searchInput) {
        this.isSearchResult = true;
      }
      if (data.type == "delete") {
        this.isSearchResult = false;
      }
      this.getExperiences();
    },*/


    deleteImage(image) {
      let experienceIndex = 0;
      console.log("this.experiences.images", this.experiences);
      this.experiences[this.experienceIndex].images = Object.values(
          this.experiences[this.experienceIndex].images
      ).filter((experienceItem, index) => {
        if (experienceItem.id == image.id) {
          experienceIndex = index;
        }
        return experienceItem.id !== image.id;
      });
    },

    getProvinces(search, loading) {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/states",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.provinces = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getExperiencesPrerequisite(stateName, url) {
      // if (typeof this.cancelToken != typeof undefined) {
      //   this.cancelToken.cancel("Operation canceled due to new request.");
      // }
      //Save the cancel token for the current request
      // this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/experiences/${url}`,
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this[stateName] = data.data;
            this[stateName].forEach((element) => {
              element["disable"] = false;
            });
          })
          .catch((err) => {
            console.log(err);
          });
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getExperiences();
    },


    async getExperiences() {
      if (this.cancelToken) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = this.$http.CancelToken.source();
      this.searchBasesubmitLoading = true;

      let params = {
        per_page: this.perPage,
        page: this.page,
      };

      if (this.searchInput) {
        if (this.selectedFilter.includes("name")) params["filter[name]"] = this.searchInput;
        if (this.selectedFilter.includes("code")) params["filter[code]"] = this.searchInput;
        if (this.selectedFilter.includes("host")) params["filter[host]"] = this.searchInput;
        if (this.selectedFilter.includes("city")) params["filter[city]"] = this.searchInput;
      }

      if (this.filters.dateStart && this.filters.dateEnd) {
        params["filter[created_between][]"] = [this.filters.dateStart, this.filters.dateEnd];
      }

      try {
        const response = await this.$http({
          method: "get",
          url: "/admin/experiences",
          params: params,
          paramsSerializer: params => {
            return Object.entries(params).map(([key, value]) => {
              if (Array.isArray(value)) {
                return value.map(v => `${key}=${encodeURIComponent(v)}`).join('&');
              }
              return `${key}=${encodeURIComponent(value)}`;
            }).join('&');
          },
          cancelToken: this.cancelToken.token,
        });

        this.experiences = response.data.data;
        this.paginationData = response.data.meta;
        this.isSearchResult = true;
      } catch (err) {
        if (!this.$http.isCancel(err)) {
          console.error(err);
        }
      } finally {
        this.searchBasesubmitLoading = false;
      }
    },


/*    async getExperiences() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        "filter[name]": this.selectedFilter.includes("name")
            ? this.searchInput
            : "",
        "filter[code]": this.selectedFilter.includes("code")
            ? this.searchInput
            : "",
        "filter[host]": this.selectedFilter.includes("host")
            ? this.searchInput
            : "",
        "filter[city]": this.selectedFilter.includes("city")
            ? this.searchInput
            : "",
        per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/experiences",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.experiences = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
      this.experiences = [];
      this.formModal = false;
    },*/
    showConfirmModal(experience) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف تجربه مطمئن هستید ؟  : ${experience.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let experienceIndex = 0;
              this.experiences = await this.experiences.filter(
                  (experienceItem, index) => {
                    if (experienceItem.id == experience.id) {
                      experienceIndex = index;
                    }
                    return experienceItem.id !== experience.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `admin/experiences/${experience.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `تجربه: ${experience.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.experiences.splice(experienceIndex, 0, experience);
                  });
            }
          });
    },
    formatePrices(prices, type) {
      if (prices.name && prices.name == "test") {
        return prices;
      }
      if (type == "prices") {
        var formatedPrices = prices;
        if (prices.normal_dayes)
          formatedPrices.normal_dayes = this.formatnumber(prices.normal_dayes);
        if (prices.weekend_days)
          formatedPrices.weekend_days = this.formatnumber(prices.weekend_days);
        if (prices.peack_days)
          formatedPrices.peack_days = this.formatnumber(prices.peack_days);
        if (prices.extra_guest)
          formatedPrices.extra_guest = this.formatnumber(prices.extra_guest);
        if (prices.pricePerBaby.price !== null) {
          formatedPrices.pricePerBaby.price = this.formatnumber(
              prices.pricePerBaby.price
          );
        }
        if (prices.pricePerAnimal.price !== null) {
          formatedPrices.pricePerAnimal.price = this.formatnumber(
              prices.pricePerAnimal.price
          );
        }
        return formatedPrices;
      }
    },
    formatnumber(newValue) {
      console.log("newValue", newValue);
      const result = newValue
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    //     monthsBetweenDates(startDate, endDate) {
    //       const now = startDate,
    //         dates = [];

    //       while (now.isSameOrBefore(endDate)) {
    //         // console.log(now.format("dddd"))
    //         if (
    //           now.format("dddd") === "پنج‌شنبه" ||
    //           now.format("dddd") === "چهارشنبه"
    //         ) {

    //           dates.push({ isWeakend: true, date: now.locale('en').format("YYYY/MM/DD"),

    //           books_count:0,
    // disable_count:0,
    // is_custom_price:false,
    // price:

    //           });
    //         } else {
    //           dates.push({ date: now.locale('en').format("YYYY/MM/DD") });
    //         }

    //         now.add(1, "days");
    //       }
    //       return dates;
    //     },
    getDatesFromStartTo6Month() {
      // console.log(this.$moment)
      const endofMonth1 = this.$moment(this.date);
      const toDate1 = this.$moment(endofMonth).endOf("month");
      console.log(endofMonth1, toDate1);
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth1,toDate1))
      // console.log("date",this.$options.filters.moment(this.date,"jD jMMMM,jYYYY HH:mm").getDay())
      // console.log(this.$moment(this.date).endOf('month').format('YYYY/MM/D'))
      const endofMonth = this.$moment(this.date).endOf("month");
      const toDate = this.$moment(endofMonth).add(6, "months").endOf("month");

      // console.log("toDate",toDate.format('YYYY/MM/D'))
      // console.log("monthsBetweenDates",this.monthsBetweenDates(endofMonth,toDate))
      var x = this.monthsBetweenDates(endofMonth1, toDate1);

      x.splice(-1);
      var y = this.monthsBetweenDates(endofMonth, toDate);
      // this.date.moment("jD jMMMM,jYYYY HH:mm").getDay()
      this.Dates = [...x, ...y];

      console.log(this.Dates);
      return this.Dates;
    },
    showFormModal(experience, index) {
      this.$refs.experienceInput.specialServices = 0;

      console.log("experience", experience);
      if (experience) {
        this.$refs.experienceInput.$refs.formWizard.activateAll()
        this.$refs.experienceInput.experienceInput = {
          id: experience.id,
          name: experience.name,
          slug: experience.slug,
          host_id: experience.host.id,
          category_id: experience.category.id,
          age_id: experience.age.id,
          experience_style: experience.experience_style,
          experience_difficulty: experience.experience_difficulty,
          min_day_before_reservation: experience.min_day_before_reservation,
          min_people: experience.min_people,
          max_people: experience.max_people,
          price: experience.price,
          price_off: experience.price_off,
          price_type: experience.price_type,
          takes_time: experience.takes_time,
          description: experience.description,
          covid: experience.covid,
          blog_url: experience.blog_url,
          plans: experience.plans,
          include: experience.include,
          exclude: experience.exclude,
          faqs: experience.faqs,
          rules: experience.rules,
          show_index_page:experience.show_index_page,
          score:experience.score,
          show_date_page:experience.show_date_page,
          // regulations: experience.regulations,
          state_id: experience.state.id,
          city_id: experience.city.id,
          address: experience.address,
          properties: experience.properties,


    
          commission_per_person: experience.commission_per_person,
          commission_per_group: experience.commission_per_group,

          lat: experience.lat,
          lng: experience.lng,
          status: experience.status,
          close_booking: experience.close_booking,
          seo_data_title: experience.seo_data.title,
          seo_data_keywords: experience.seo_data.keywords,
          seo_data_description: experience.seo_data.description,
          seo_data_schema: experience.seo_data.schema,
          videos: experience.videos,
          podcasts: experience.podcasts,
          status: experience.status,
          agency: experience.agency,
          close_booking: experience.close_booking,
          images: experience.images,
          show_order_number: experience.show_order_number,
        };


        // (this.$refs.experienceInput.regulationsItemArray =
        //   experience.regulations),
        this.$refs.experienceInput.categories =
            this.categories;

        this.$refs.experienceInput.properties =
            this.properties;

        this.$refs.experienceInput.ages =
            this.ages;



        var regulationsData = [];
        if(this.regulations.length>0){
          this.regulations.forEach(
              (initialRegulation, index) => {
                regulationsData.push(initialRegulation);
                experience.regulations.forEach((saveRegulation) => {
                  if (
                      initialRegulation.id == saveRegulation.experience_regulation.id
                  ) {
                    regulationsData[index] = saveRegulation;
                  }
                });
              }
          );
        }


        if(this.rules.length>0){
          this.rules.forEach(
              (rule, index) => {
                if(experience.rules){

                }

              }


          );

        }



        this.$refs.experienceInput.helperRegulation = [...experience.regulations];
        this.$refs.experienceInput.helperRules = [...experience.rules];


        this.$refs.experienceInput.regulationsItemArray = regulationsData,

            this.$refs.experienceInput.rules = this.rules;


       

        this.$refs.experienceInput.getCityByProvinceId(experience.state.id);
        this.$refs.experienceInput.searchLatLng();
        this.$refs.experienceInput.experienceIndex = index;

        this.experienceIndex = index;
        this.editMode = true;
        this.$refs.experienceInput.dates = null;
        this.$refs.experienceInput.editMode = this.editMode;






      }

      else {
        this.$refs.experienceInput.$refs.formWizard.reset ()

        this.$refs.experienceInput.experienceInput = {
          id: "",
          name: "",
          slug: "",
          host_id: "",
          category_id: "",
          age_id: "",
          experience_style: "",
          experience_difficulty: "",
          min_day_before_reservation: "",
          min_people: "",
          max_people: "",
          price: "",
          takes_time: "",
          description: "",
          covid: "",
          commission_per_person: "",
          commission_per_group: "",
          show_order_number: "",
          show_index_page: "",
          score: "",
          show_date_page: "",
          faqs: [],
          plans: [],
          include: [],
          exclude: [],
          rules:[],
          properties: {},
          // regulations:{},
          state_id: "",
          city_id: "",

          lat: "",
          lng: "",
          status: "",
          close_booking: "",
          seo_data_title: "",
          seo_data_keywords: "",
          seo_data_description: "",
          seo_data_schema: "",
          videos: "",
          podcasts: "",
          status: "active",
          agency: "active",
          close_booking: "active",
        };


        this.$refs.experienceInput.categories =
            this.categories;

        this.$refs.experienceInput.properties =
            this.properties;

        this.$refs.experienceInput.ages =
            this.ages;


        (this.$refs.experienceInput.regulationsItemArray =
            this.regulations),


            (this.$refs.experienceInput.rules = this.rules);
        (this.$refs.experienceInput.specialServices = 0);
       
        this.$refs.experienceInput.experienceIndex = 0;

        this.editMode = false;
        this.$refs.experienceInput.editMode = this.editMode;
      }
      // this.$refs.experienceInput.dates=this.getDatesFromStartTo6Month()
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.experienceInput.building_id) {
        errorMessage = "لطفا یک کاربر را انتخاب کنید";
      }
      if (!errorMessage && !this.experienceInput.name) {
        errorMessage = "لطفا رمز را وارد کنید";
      }

      if (!errorMessage && !this.experienceInput.description) {
        errorMessage = "لطفا توضیحات را وارد کنید";
      }

      if (!errorMessage && !this.experienceInput.body) {
        errorMessage = "لطفا متن را وارد کنید";
      }

      if (!errorMessage && !this.experienceInput.count) {
        errorMessage = "لطفا تعداد را وارد کنید";
      }

      if (!errorMessage && !this.experienceInput.bedrooms) {
        errorMessage = "لطفا تعداد اتاق خواب را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "patch" : "post",
        url: this.editMode
            ? `experiences/${this.experienceInput.id}`
            : `experiences`,
        data: this.experienceInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "تجربه با موفقیت اضافه شد";
            if (this.editMode) message = "تجربه با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.buildings && this.buildings.length > 0) {
              this.$refs.experiencesPaginationComponent.clear();
              this.$refs.experiencesSearchComponent.clear();
              this.$refs.experiencesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getExperiences();
          })
          .catch((err) => {
            let message = "خطا در ایجاد تجربه";
            if (this.editMode) message = "خطا در ویرایش تجربه";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data.data;
            this.buildings = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
